/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface AggiornamentoRicarica { 
    id?: string;
    operatore?: string;
    dataOperazione?: Date;
    operazioni?: Array<string>;
    commentoOperatore?: string;
    created_at?: Date;
    updated_at?: Date;
}